/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Dropzone_AcceptInputs */

const en_case_dropzone_accept = /** @type {(inputs: Case_Dropzone_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents, images, and videos · files up to 50 MB, videos up to 250 MB`)
};

const pt_br2_case_dropzone_accept = /** @type {(inputs: Case_Dropzone_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos, imagens e vídeos · arquivos de até 50 MB, vídeos de até 250 MB`)
};

/**
* | output |
* | --- |
* | "Documents, images, and videos · files up to 50 MB, videos up to 250 MB" |
*
* @param {Case_Dropzone_AcceptInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_dropzone_accept = /** @type {((inputs?: Case_Dropzone_AcceptInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Dropzone_AcceptInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_dropzone_accept(inputs)
	return pt_br2_case_dropzone_accept(inputs)
});